module.exports = __webpack_public_path__ + "src/assets/sounds/animalSound.wav";